import { Container, Grid, StrapiSectionWrapper, ThemeWrapper, ValueProp } from "@theme/components";

import type { StrapiBackgroundColor, StrapiValuePropProps } from "@ms/gatsby-site/src/types/strapi";
import type { MsComponentPropsWithoutRef } from "@theme/types/global";
import type { FC } from "react";

interface ValuePropsProps extends MsComponentPropsWithoutRef<"div"> {
  anchorId?: string | null;
  sectionName: string;
  theme: "Dark" | "Light";
  bgColor: StrapiBackgroundColor | null;
  valueProps: StrapiValuePropProps[];
}

export const ValueProps: FC<ValuePropsProps> = ({
  anchorId,
  theme,
  bgColor,
  valueProps,
  sectionName,
  sx,
  ...props
}) => {
  const valuePropsLength = valueProps.length;
  const collapseColsOnMobile = valuePropsLength > 3;

  return (
    <ThemeWrapper theme={theme}>
      <StrapiSectionWrapper
        anchorId={anchorId}
        data-strapi-module="ValueProp"
        data-strapi-section={sectionName}
        sx={{ bg: bgColor?.key ?? "backgroundLevel2" }}
      >
        <Container
          variant="wide"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: ["s500", null, "s700"],
            py: "s600",
            ...sx,
          }}
          {...props}
        >
          <Grid
            sx={{
              gap: "s500",
              gridTemplateColumns: [
                collapseColsOnMobile ? "repeat(2, 1fr)" : `repeat(${valuePropsLength}, 1fr)`,
                `repeat(${valuePropsLength}, 1fr)`,
              ],
            }}
          >
            {valueProps?.map((value) => (
              <ValueProp key={value.id} {...value} />
            ))}
          </Grid>
        </Container>
      </StrapiSectionWrapper>
    </ThemeWrapper>
  );
};
